import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ProductService {

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get(`products`);
  }
  
  getProducts(pageNo: number , itemsPerpage: number): Observable<any> {
    return this.http.get(`products?page=${pageNo}&items_per_page=${itemsPerpage}`);
  }

  searchAll(search_string) : Observable<any>{
    return this.http.get(`products?search=${search_string}`)
  }

  getProductByCategory(categoryId) : Observable<any>{
    return this.http.get(`products?category_id=${categoryId}`)
  }


  createOrder(payload: object): Observable<any> {
    return this.http.post("orders", JSON.stringify(payload));
  }

  getUSSD(): Observable<any> {
    return this.http.get(`ussd-codes`);
  }

  getProduct(id:number): Observable<any>{
    return this.http.get(`products/${id}`);
  }
  
  getBanners(): Observable<any> {
    return this.http.get(`banners?display_location=PRODUCTS`);
  }
  

  // getAll(){
  //   return this.products ;
  // }
}
